import { useEffect, useState } from "react";
import { api, formatApiError } from "@/api/client";

const initial = { code: "", owner_name: "", discount_percent: 1, commission_percent: 1, starts_at: "", ends_at: "" };

export default function PromoCodesPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(initial);
  const [error, setError] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/admin/promo-codes"); setItems(data.items || []); }
    catch (e) { setError(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const add = async (event) => {
    event.preventDefault();
    try {
      await api.post("/admin/promo-codes", {
        ...form,
        discount_percent: Number(form.discount_percent),
        commission_percent: Number(form.commission_percent),
        starts_at: new Date(form.starts_at).toISOString(),
        ends_at: new Date(form.ends_at).toISOString(),
      });
      setForm(initial); setError(""); load();
    } catch (e) { setError(formatApiError(e)); }
  };
  const toggle = async (item) => {
    await api.patch(`/admin/promo-codes/${item._id}`, { is_active: !item.is_active });
    load();
  };

  return <main dir="rtl" className="max-w-6xl mx-auto p-6 space-y-6" data-testid="promo-codes-page">
    <div><h1 className="text-2xl font-bold">أكواد الخصم والتسويق</h1><p className="text-slate-500">الخصم والعمولة واستخدام الكود المعتمد.</p></div>
    {error && <div className="rounded bg-red-50 text-red-700 p-3">{error}</div>}
    <form onSubmit={add} className="grid md:grid-cols-3 gap-3 rounded-xl border p-4 bg-white">
      <input required placeholder="كود حروف وأرقام" value={form.code} onChange={e => setForm({...form, code:e.target.value.toUpperCase()})} className="border rounded p-2" />
      <input required placeholder="اسم صاحب الكود" value={form.owner_name} onChange={e => setForm({...form, owner_name:e.target.value})} className="border rounded p-2" />
      <input required type="number" min="1" max="15" placeholder="خصم العميل %" value={form.discount_percent} onChange={e => setForm({...form, discount_percent:e.target.value})} className="border rounded p-2" />
      <input required type="number" min="1" max="15" placeholder="عمولة صاحب الكود %" value={form.commission_percent} onChange={e => setForm({...form, commission_percent:e.target.value})} className="border rounded p-2" />
      <input required type="datetime-local" value={form.starts_at} onChange={e => setForm({...form, starts_at:e.target.value})} className="border rounded p-2" />
      <input required type="datetime-local" value={form.ends_at} onChange={e => setForm({...form, ends_at:e.target.value})} className="border rounded p-2" />
      <button className="rounded bg-blue-700 text-white p-2">إضافة الكود</button>
    </form>
    <div className="overflow-auto rounded-xl border bg-white"><table className="w-full text-sm"><thead><tr className="bg-slate-50"><th>الكود</th><th>المالك</th><th>الخصم</th><th>العمولة</th><th>الاستخدام</th><th>الخصم الإجمالي</th><th>مستحق المالك</th><th>الحالة</th></tr></thead><tbody>{items.map(item => <tr key={item._id} className="border-t text-center"><td className="p-3 font-mono">{item.code}</td><td>{item.owner_name}</td><td>{item.discount_percent}%</td><td>{item.commission_percent}%</td><td>{item.approved_usage_count}</td><td>{item.total_discount_amount} ر.س</td><td>{item.total_commission_amount} ر.س</td><td><button className="px-3 py-1 rounded bg-slate-100" onClick={() => toggle(item)}>{item.is_active ? "نشط" : "متوقف"}</button></td></tr>)}</tbody></table></div>
  </main>;
}